import React from 'react';
import styled from 'styled-components';
import { getVariantPropFromString } from 'gatsby-theme-core/src/components/button/get-variant';
import Column from 'gatsby-theme-pagebuilder/src/components/column/index';
import Content from 'gatsby-theme-pagebuilder/src/components/content';
import { useContentTheme } from 'gatsby-theme-pagebuilder/src/components/content-theme';
import Form from '../../../../components/form';
import Title from './title';

const PagebuilderForm = ({
  variant,
  buttonVariant,
  form,
  justify,
}) => {
  // eslint-disable-next-line no-unused-vars
  const { contentTheme } = useContentTheme();
  return (
    <Form
      {...form}
      horizontal={variant === 'horizontal' || variant === 'standout'}
      standout={variant === 'standout'}
      justify={justify}
      buttonProps={getVariantPropFromString(buttonVariant)}
    />
  );
};

const StyledContent = styled(Content)`
  width: 100%;
`;

const FormBlock = ({
  // id,
  identifier,
  columnWidth,
  align,
  justify,
  title,
  card,
  order,
  variant,
  form,
  buttonVariant,
  offset,
}) => (
  <Column
    columnWidth={columnWidth}
    align={align}
    justify={justify}
    card={card}
    order={order}
    offset={offset}
    id={identifier}
  >
    <StyledContent textAlign={justify}>
      {title && <Title>{title}</Title>}
      <PagebuilderForm
        variant={variant}
        buttonVariant={buttonVariant}
        form={form}
        justify={justify}
      />
    </StyledContent>
  </Column>
);

export default styled(FormBlock)``;
